import { get } from 'lodash';

import { RootState } from '../store';
import { nameSpace as projectV2NameSpace } from './projectReducer';

export const getProjectDetails = (state: RootState) => get(state, [projectV2NameSpace, 'projectDetails']) || { data: null };
export const getUserRoles = (state: RootState) => get(state, [projectV2NameSpace, 'userRoles']) || { loading: false, data: [] };
export const getUserRoleCompany = (state: RootState) => get(state, [projectV2NameSpace, 'roleCompany']) || { data: [] };
